var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M31.034 14.374c3.508-.65 3.587-6.297-.051-6.254-2.847.034-2.56 2.795-2.945 2.252-.748-1.055-.989-3.769 1.862-4.894 2.461-.971 5.846.996 6.063 4.591.139 2.302-1.297 6.554-6.453 5.846-7.222-.991-1.983-.892 1.524-1.541z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M10.321 21.935s1.016 2.352.676 8.242c-.061 1.057-.209 2.136-.242 3.022-1.812 0-1.652 2.064-1.268 2.064h2.902c.683 0 1.893-3.438 2.212-8.209.319-4.772-4.28-5.119-4.28-5.119zm11.89-.331s.575 3.528 3.651 6.413c.257 1.163.769 4.232.949 5.195-1.889 0-1.282 2.047-.731 2.047h2.646c.951 0 1.092-3.442.206-7.694-.885-4.251-6.721-5.961-6.721-5.961z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D99E82",
    d: "M32.202 15.654c-1.253-3.752-7.214-3.628-13.997-2.765-3.055.389-3.64-4.453-3.64-5.286 0-3.626-3.244-5.455-6.496-4.229-.779.293-1.402 1.33-1.754 1.872-1.977 3.037-4.658.015-4.917 2.822-.313 3.395 1.721 4.534 5.051 4.821 1.892.163 3.459 1.095 3.871 5.044.154 1.472-.295 5.644 2.388 7.076.78 2.959 1.836 6.615 2.25 8.475-2.252.476-1.341 2.179-1.341 2.179s3.151-.043 3.836-.043c.814 0 .191-5.976-.935-9.787 4.764.043 7.828-1.337 8.799-1.762 1.028 2.96 4.152 3.633 4.851 4.892.433.78 1.878 3.383 2.001 4.496-1.602.52-1.091 1.732-.909 2.122 1.083-.043 3.22-.043 3.498-.043 1.11 0-1.137-6.904-2.083-8.713-1.082-2.071.781-7.419-.473-11.171z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C7B5",
    d: "M16.266 24.464c.044.371.141.891.253 1.369 4.764.043 7.828-1.337 8.799-1.762-.215-.78-.23-1.27-.171-1.538-3.394.557-4.548 2.205-8.881 1.931zM6.449 12.889c1.892.163 2.425 1.069 2.838 5.018.154 1.472.739 5.67 3.421 7.102-.72-2.788-1.959-12.388-6.259-12.12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4C7B5",
    d: "M3.153 6.665c-2.793 0-1.909.526-2.002 1.692-.093 1.166-.074 2.976.776 3.929 1.127 1.262 3.858 1.266 5.215.277s-.424-5.898-3.989-5.898z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#272B2B",
    d: "M2.503 8.326c-.109.762-.494 1.192-.879 1.133C.864 9.342.232 8.372.232 7.603s.624-.963 1.392-.928c1.043.048 1.002.788.879 1.651z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M15.167 9.026c.348 2.515-1.157 2.898-2.383 2.898s-3.054-1.25-2.748-3.77c.134-1.107.555-2.193.809-3.175.336-1.303 1.199-1.732 1.894-1.367 1.665.874 2.203 3.797 2.428 5.414z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#292F33",
    cx: 8.069,
    cy: 6.675,
    r: 0.928
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M19.035 12.789c.073 1.532.906 3.178 2.733 3.663 1.901.505 4.12.127 4.67-2.475.091-.43.13-1.224.073-1.514-2.151-.179-4.73 0-7.476.326z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#D99E82",
    cx: 3.053,
    cy: 10.503,
    r: 0.488
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#D99E82",
    cx: 3.695,
    cy: 9.804,
    r: 0.269
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#D99E82",
    cx: 4.1,
    cy: 10.503,
    r: 0.269
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.ef4b1a8e601306106cb38ea9799c1533.svg";
export { ForwardRef as ReactComponent };